export const fieldNames = {
  code: {
    // 製造/車台番号
    name: 'code',
    type: 'text',
    label: 'FORKLIFT_COMMON_CODE_LABEL',
    operator: 'ilike',
    queryName: 'code',
    maxLength: 255,
    tabIndexes: [0]
  },
  purchaseDate: {
    // 購入/契約年月
    name: 'purchaseDate',
    type: 'month',
    label: 'FORKLIFT_COMMON_PURCHASEDATE_LABEL',
    tabIndexes: [1, 2]
  },
  holdingFormat: {
  // 保有形式
    label: 'FORKLIFT_COMMON_HOLDINGFORMAT_LABEL',
    name: 'holdingFormat',
    type: 'dropdown',
    selectOptions: '45',
    tabIndexes: [3, 4]
  },
  owner: {
  // 所有者
    label: 'FORKLIFT_COMMON_OWNER_LABEL',
    name: 'owner',
    type: 'dropdown',
    selectOptions: '46',
    tabIndexes: [5]
  },
  user: {
  // 使用者
    label: 'FORKLIFT_COMMON_USER_LABEL',
    name: 'user',
    type: 'dropdown',
    selectOptions: '47',
    tabIndexes: [6]
  },
  userAddress: {
  // 使用の本拠の位置
    label: 'FORKLIFT_COMMON_USERADDRESS_LABEL',
    name: 'userAddress',
    type: 'text',
    maxLength: 255,
    tabIndexes: [7]
  },

  annualInspectionDate: {
  // 年次点検日（前回）
    label: 'FORKLIFT_COMMON_ANNUALINSPECTIONDATE_LABEL',
    name: 'annualInspectionDate',
    type: 'date',
    tabIndexes: [8, 9]
  },
  expensesIncludingLease: {
  // リース代に含む諸費用
    label: 'FORKLIFT_COMMON_EXPENSESINCLUDINGLEASE_LABEL',
    name: 'expensesIncludingLease',
    type: 'dropdown',
    selectOptions: '48',
    tabIndexes: [10]
  },
  leaseEndDate: {
  // リース期限
    label: 'FORKLIFT_COMMON_LEASEENDDATE_LABEL',
    name: 'leaseEndDate',
    type: 'date',
    tabIndexes: [11, 12]
  },
  leaseFee: {
  // 月額リース料
    label: 'FORKLIFT_COMMON_LEASEFEE_LABEL',
    name: 'leaseFee',
    type: 'number',
    tabIndexes: [13, 14]
  },
  rentalEndDate: {
  // レンタル期限
    label: 'FORKLIFT_COMMON_RENTALENDDATE_LABEL',
    name: 'rentalEndDate',
    type: 'date',
    tabIndexes: [15, 16]
  },
  rentalFee: {
  // 月額レンタル料
    label: 'FORKLIFT_COMMON_RENTALFEE_LABEL',
    name: 'rentalFee',
    type: 'number',
    tabIndexes: [17, 18]
  },
  inspectionExpireDate: {
  // 車検証期限
    label: 'FORKLIFT_COMMON_INSPECTIONEXPIREDATE_LABEL',
    name: 'inspectionExpireDate',
    type: 'date',
    tabIndexes: [19, 20]
  },
  automobileTax: {
  // 自動車税
    label: 'FORKLIFT_COMMON_AUTOMOBILETAX_LABEL',
    name: 'automobileTax',
    type: 'number',
    tabIndexes: [21, 22]
  },
  weightTax: {
  // 重量税
    label: 'FORKLIFT_COMMON_WEIGHTTAX_LABEL',
    name: 'weightTax',
    type: 'number',
    tabIndexes: [23, 24]
  },
  mandatoryInsuranceEndDate: {
  // 自賠責保険期限
    label: 'FORKLIFT_COMMON_MANDATORYINSURANCEENDDATE_LABEL',
    name: 'mandatoryInsuranceEndDate',
    type: 'date',
    tabIndexes: [25, 26]
  },
  voluntaryInsuranceType: {
  // 任意保険種別
    label: 'FORKLIFT_COMMON_VOLUNTARYINSURANCETYPE_LABEL',
    name: 'voluntaryInsuranceType',
    type: 'dropdown',
    selectOptions: '49',
    tabIndexes: [27]
  },
  voluntaryInsuranceEndDate: {
  // 任意保険期限
    label: 'FORKLIFT_COMMON_VOLUNTARYINSURANCEENDDATE_LABEL',
    name: 'voluntaryInsuranceEndDate',
    type: 'date',
    tabIndexes: [28, 29]
  }
}
